import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { PREVIEW_PRODUCTS } from "@/lib/catalog";
import { landingMarkup } from "@/lib/landingMarkup";
import { initLanding } from "@/lib/landingInteractions";
import { initProteinCalculator } from "@/lib/proteinCalculator";
import "@/lenis-landing.css";
import "@/product-showcase.css";
import "@/protein-calculator.css";

// Stable content prevents React context updates from replacing bound DOM nodes.
const landingContent = { __html: landingMarkup };

export default function Home() {
  const root = useRef(null);
  const actions = useRef(null);
  const { addItem, setIsOpen, count } = useCart();
  const { user, openAuth } = useAuth();
  const navigate = useNavigate();
  actions.current = {
    addPlant: () => addItem(PREVIEW_PRODUCTS[0]),
    openCart: () => setIsOpen(true),
    openAccount: () => user ? navigate("/account") : openAuth("login"),
  };
  useEffect(() => {
    const disposeLanding = initLanding(root.current, {
      addPlant: () => actions.current.addPlant(),
      openCart: () => actions.current.openCart(),
      openAccount: () => actions.current.openAccount(),
    });
    const disposeCalculator = initProteinCalculator(root.current);
    return () => {
      disposeCalculator();
      disposeLanding();
    };
  }, []);
  useEffect(() => {
    root.current.querySelector("#bag-count").textContent = count;
    root.current.querySelector("[data-cart]").setAttribute("aria-label", "Open cart, " + count + " items");
  }, [count]);
  return <div ref={root} className="lenis-landing" dangerouslySetInnerHTML={landingContent} />;
}


